import MUserDetailsContent from './MUserDetailsContent.vue';

export { MUserDetailsContent };
export default MUserDetailsContent;
